var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}]},[_c('el-card',{attrs:{"shadow":"never"}},[_c('Manifest',{ref:"manifest",attrs:{"form-data":_vm.formData.manifestData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }